
export default {
    /**
     * 设置cookie
     * @param {*} cookieName 
     * @param {*} value 
     * @param {*} days 
     */
    set(cookieName, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = cookieName + "=" + value + expires + "; path=/";
    },

    /**
     * 获取cookie
     * @param {*} name 
     * @returns 
     */
    get(name) {
        var cookieName = name + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var cookieArray = decodedCookie.split(';');
        for (var i = 0; i < cookieArray.length; i++) {
            var cookie = cookieArray[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(cookieName) === 0) {
                return cookie.substring(cookieName.length, cookie.length);
            }
        }
        return null;
    },

    /**
     * 删除cookie
     * @param {*} name 
     */
    delete(name) {
        this.set(name, null, -1);
    },
};



